import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import UserManagement from "./UserManagement";
import GroupManagement from "./GroupManagement";
import theme, { tabsStyle } from "../../../Constants/theme";
const Management = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        py: 2,
        backgroundColor: theme.backgroundColors.dark.primary,
      }}
    >
      <Tabs value={selectedTab} onChange={handleChange} centered sx={tabsStyle}>
        <Tab label="User Management" />
        <Tab label="Group Management" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {selectedTab === 0 && <UserManagement />}
        {selectedTab === 1 && <GroupManagement />}
      </Box>
    </Box>
  );
};

export default Management;
